import React from 'react';
import { DescriptionColumn } from './description-column';
import { ProviderColumn } from './provider-column';
import { Row } from './row';

export const DeductionsRow = ({ providers, deductionsLabel, deductionsProviderValues }) => (
  <Row>
    <DescriptionColumn fontSize={16} padding={'15px 0px 0px 0px'}>
      {deductionsLabel}
    </DescriptionColumn>
    {providers.map((provider, index) => {
      const value = deductionsProviderValues.find((values) => values.providerID === provider.id)?.value || '';
      return (
        <ProviderColumn key={`providerDeductions_${provider.id}`} isLast={index === providers.length - 1}>
          {value}
        </ProviderColumn>
      );
    })}
  </Row>
);
